var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ObjectLayoutWidget } from '../angular2-schema-form-shim';
import { isWidgetRequired } from './overrides';
var POPQWidget = (function (_super) {
    __extends(POPQWidget, _super);
    function POPQWidget() {
        return _super.call(this) || this;
    }
    Object.defineProperty(POPQWidget.prototype, "widget", {
        get: function () {
            var widget = this.schema.widget;
            return typeof widget === 'string' ? { id: widget } : widget;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(POPQWidget.prototype, "required", {
        get: function () {
            return isWidgetRequired(this);
        },
        enumerable: true,
        configurable: true
    });
    return POPQWidget;
}(ObjectLayoutWidget));
export { POPQWidget };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/popq.widget.ts.pre-build-optimizer.js